import { Component, OnInit, HostListener } from '@angular/core';
import { DataSharingService } from '../_services/data-sharing.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public rootScope: any;
  public navCollapsed: boolean = true;
  public logoWb: string;
  public wb: any;
  public showMenu: boolean;
  private locationWb: string = '/whitebranding/';
  public isReportPage: boolean;
  public isPortraitOrientation: boolean;
  public toolbarStyling = {
    backgroundColor: '#04884b',
    color: '#ffffff'
  };


  constructor(
    private dataSharingService: DataSharingService,
    private router: Router,
    private location: Location,
    private translate: TranslateService,
    private cookieService: CookieService) {
  }

  ngOnInit() {
    this.setRootScope();
    this.setWhiteBranding();
    this.checkPage();
  }

  private checkPage() {
    this.location.onUrlChange(url => {
      this.checkIfLoginPage(url);
      this.checkIfReportPageAndForceLandscape(url);
    });
  }

  private setRootScope() {
    this.dataSharingService.rootScope.subscribe(rootScope => {
      this.rootScope = rootScope;
    });
  }

  private setWhiteBranding() {
    this.dataSharingService.whiteBranding.subscribe(res => {
      if (res) {
        this.wb = res;
        this.setToolbarStyling();
      }
    });
  }

  setToolbarStyling() {
      this.toolbarStyling.backgroundColor = this.wb.menuBgCol;
      this.toolbarStyling.color = this.wb.menuTxtCol;
  }

  getToolbarStyling() {
    if (this.showMenu) {
      return { backgroundColor: this.toolbarStyling.backgroundColor, color: this.toolbarStyling.color };
    } else {
      return { 'justify-content': 'flex-end' };
    }
  }

  getNavlinkStyling(isActive) {
    return {
      backgroundColor: isActive ? this.wb.menuActiveBgCol : ''
    };
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    if (this.isReportPage === true) {
      this.isPortraitOrientation = !this.isPortraitOrientation;
    }
  }

  // Prevent user from CTRL-P Printing
  @HostListener('window:keydown', ['$event'])
  onKeyPress($event: KeyboardEvent) {
    if (($event.ctrlKey || $event.metaKey) && $event.keyCode == 80) {
      event.preventDefault();
    }
  }


  checkIfLoginPage(url) {
    if (url === '/' || url === '/login') {
      return this.showMenu = false;
    } else {
      return this.showMenu = true;
    }
  }

  checkIfReportPageAndForceLandscape(url) {
    let urlRegex = new RegExp('generate', 'g')
    if (urlRegex.exec(url)) {
      this.checkIfPortraitOrientation();
      return this.isReportPage = true;
    } else {
      this.isPortraitOrientation = false;
      return this.isReportPage = false;
    }
  }

  checkIfPortraitOrientation() {
    if (window.matchMedia('(orientation: portrait)').matches) {
      this.isPortraitOrientation = true;
    }
  }

  isAuthenticated() {
    return this.rootScope.$$childHead.user.authenticated;
  }

  isAuthenticatedAndConnected() {
    return this.rootScope && this.rootScope.$$childHead.connected && this.rootScope.$$childHead.user.authenticated;
  }

  getActiveMenu() {
    let activeMenu = this.rootScope.$$childHead.activeMenu;

    if (!activeMenu) {
      return this.router.url.startsWith('/ppr') ? 'ppr' : '';
    }
    return this.rootScope.$$childHead.activeMenu;
  }

  mobileNavCollapse() {
    if (this.navCollapsed) {
      this.gotoTop();
    }
    this.navCollapsed = !this.navCollapsed;

  }

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getCurrentLanguage() {
    return this.cookieService.get('PORTAL_LANG_KEY') + '_' + this.cookieService.get('PORTAL_LANG_COUNTRY');
  }

  logout() {
    this.router.navigate(['/']);
    this.rootScope.$$childHead.logout();
  }

  changeLocale(locale: string) {
    let localeParts = locale.split('_');
    let lang = localeParts[0];
    let country = localeParts[1];

    this.cookieService.set('PORTAL_LANG_COUNTRY', country);

    this.rootScope.$$childHead.changeLocale(lang);
    this.translate.use(lang);
  }

  navigate(path: string) {
    if (path === 'ppr') {
      this.router.navigate([path]);
    } else {
      this.router.navigate(['/']);
      this.location.go(path);
    }

  }

  returnWbLogo() {
    if (typeof (this.rootScope) == 'undefined') {
      return 'images/logo.svg'
    } else
      this.logoWb = this.locationWb + this.rootScope.wb.logo;
    return this.logoWb
  }
}
